import { render, staticRenderFns } from "./_head-area.vue?vue&type=template&id=455fcb72&scoped=true&"
import script from "./_head-area.vue?vue&type=script&lang=js&"
export * from "./_head-area.vue?vue&type=script&lang=js&"
import style0 from "./_head-area.vue?vue&type=style&index=0&id=455fcb72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455fcb72",
  null
  
)

export default component.exports